"use client";

import React, { startTransition, useEffect, useContext } from 'react';
import { useSDUIFlowLayoutItemOnVisibilityRendererSetTopAnchorVisible } from './SDUIFlowLayoutItemOnVisibilityRendererContext';
import { useDoActionWhenVisible } from '@faire/web/ui/hooks/useDoActionWhenVisible';
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { FilterablePaginatedSectionContext } from '../../SectionRenderers/FilterablePaginatedSection/__internal__/FilterablePaginatedSectionContext';


export const SDUIFlowLayoutItemTopAnchorRenderer = () => {
  const setTopAnchorVisible = useSDUIFlowLayoutItemOnVisibilityRendererSetTopAnchorVisible();
  const { setIsTransitioning, isTransitioning } = useContext(FilterablePaginatedSectionContext);
  const ref = useDoActionWhenVisible(() => {
    startTransition(() => {
      setTopAnchorVisible?.(true);
      setIsTransitioning?.(false);
    });
  });

  useEffect(() => {
    if(!isTransitioning) {
      startTransition(() => {
        setTopAnchorVisible?.(true);
      });
    }
  }, [isTransitioning, setTopAnchorVisible]);

  return (<div ref={ref} className="w-full h-[1px] mt-[-1px]"></div>);
};
